import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    initTimesheetData: [],
    timesheetItems: [],
    timesheetData: {}
  },
  getters: {
    initTimesheetData (state) {
      return state.initTimesheetData
    },
    timesheetItems (state) {
      return state.timesheetItems
    }
  },
  mutations: {
    setInitTimesheetData (state, payload) {
      console.log('setInitTimesheetData', payload)
      state.initTimesheetData = payload
    },
    setTimesheetItems (state, payload) {
      state.timesheetItems = payload
    }
  },
  actions: {
    /*createTimesheet ({ commit, dispatch }, payload) {
      console.log('actions createTimesheet', payload)
      return new Promise((resolve, reject) => {
        Vue.axios.post(`${config.serverURI}/timesheets`, payload).then((response) => {
          console.log('on create timesheet', response)
          dispatch('snackbarOnSaveSuccess')
          resolve(response)
        }).catch((error) => {
          console.log('createTimesheet', error)
          reject(error)
          dispatch('snackbarOnLoadFail', error)
        })
      })
    },*/
    exportTimesheet ({ commit, dispatch }, payload) {
      console.log('exportTimesheet -->', payload)
      Vue.axios.get(`${config.serverURI}/coursePlans/exportTimesheet?fromDate=${payload.fromDate}&toDate=${payload.toDate}&sectionId=${payload.sectionId}`).then((response) => {
        console.log('exportTimesheet', response)
      }).catch((error) => {
        console.log(error)
        dispatch('snackbarOnLoadFail', error)
      })
    },
    fetchTimesheetsByCourse ({ commit, dispatch }, payload) {
      console.log('actions fetchTimesheetsByCourse')
      Vue.axios.get(`${config.serverURI}/timesheets/findAllByCoursePlan/${payload}`).then((response) => {
        console.log('fetchTimesheetsByCourse', response.data)
        commit('setTimesheetItems', response.data)
      }).catch((error) => {
        console.log(error)
        dispatch('snackbarOnLoadFail', error)
      })
    },
    initTimesheetByCoursePlan ({ commit, dispatch }, payload) {
      console.log('actions initTimesheetByCoursePlan', payload)
      Vue.axios.get(`${config.serverURI}/timesheets/initTimesheetByCoursePlan/${payload}`).then((response) => {
        console.log('initTimsheetByCoursePlan', response.data)
        commit('setInitTimesheetData', response.data)
      }).catch((error) => {
        console.log(error)
        dispatch('snackbarOnLoadFail', error)
      })
    },

    createTimesheet(commit, payload) {
      console.log('createTimesheet payload', payload)
      return Vue.axios.get(`${config.serverURI}/timesheets/create/${payload}`)
    },
    loadItemsByCoursePlan ({ commit, dispatch }, payload) {
      console.log('actions loadItemsByCoursePlan')
      return Vue.axios.get(`${config.serverURI}/timesheets/findAllByCoursePlan/${payload}`)
    },
    completed ({ commit, dispatch }, payload) {
      console.log('actions completed', payload)
      return Vue.axios.put(`${config.serverURI}/timesheets/completed`, payload)
    },
    reCalculateWages ({ commit, dispatch }, payload) {
      console.log('actions reCalculateWages', payload)
      return Vue.axios.get(`${config.serverURI}/timesheets/reCalculateWage/${payload}`)
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/timesheet.js